import React, {Component} from 'react'
import Meta from "../Meta";
import Header from "../header";
import Paiement from "../../../components/paiement";
import Router,{ useRouter } from 'next/router';
import Loader from "../loader";
import Footer from "../footer";
import {t} from "@lingui/core/macro"
import { loadPaiementConfig } from "../../../services/paiementLauncher";

class PaiementPage extends Component{

    state={
        config:null
    }

    componentDidMount()
    {
        const router=this.props.router
        const context=this.props.context
        const {org}=context

        if(context.page.config)
        {
            this.setState({config:context.page.config})

        }else
        {
            try{
                // Pas de config lisible (panier trop volumineux pour l’URL, stockage
                // de session cloisonné par site hôte, valeur corrompue) : `loadPaiementConfig`
                // renvoie null sans lever, donc le catch ci-dessous ne peut plus jouer.
                // Sans ce repli, le donateur resterait devant une page vide.
                const config=loadPaiementConfig(org)
                if(config){
                    this.setState({config})
                }else if(typeof window !== "undefined"){
                    window.location.href=org.BASE_WEB_URL
                }else{
                    router.replace(org.BASE_WEB_URL)
                }
            }catch (e){

                if(typeof window !== "undefined"){
                    window.location.href=org.BASE_WEB_URL
                }else{
                    router.replace(org.BASE_WEB_URL)
                }

            }
        }
    }

    render(){
        const context=this.props.context
        const campagneData=this.props.campagneData

        const {org}=context
        const title=t`Don pour ${this.props.campagneData?.label}`
        const description=null

        if(this.props.loading){
            return (
                <div>
                    <Meta context={context} title={title} description={description}/>
                    <Loader/>
                </div>
            )
        }

        return(
            <div className={"campagne-page"}>
                <Meta context={context} title={title} description={description}/>
                <Header context={context} campagneData={campagneData} />
                <div style={{marginTop: 20}}>
                    {!!this.state.config && <Paiement context={context} config={{...this.state.config}}/>}
                </div>
                <Footer context={context}/>
            </div>
        )
    }
}

function withHook(Comp)
{
    return (props)=>{
        var router=useRouter()
        return <Comp router={router} {...props}/>
    }
}

export default withHook(PaiementPage)
